<template>
  <div class="events-list-wrap create-profile-wrapper">
    <div class="top-head">
      <div class="container">
        <div class="list-wrap">
          <div class="back">
            <router-link :to="`/athelete/${ProfileData._id}`">
              <a-icon type="arrow-left" />Back to profile
            </router-link>
          </div>
          <div class="event-types">
            <div class="type" @click="changeEvents('new')">Upcoming Events</div>
            <div class="type" @click="changeEvents('past')">Past Events</div>
            <div class="type" @click="changeEvents('hidden')">
              Hidden Events
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="events-content-wrap">
        <div class="head">
          <h2 class="form-title">{{ pageTitle }}</h2>
          <div class="add-event">
            <a-button
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="saveForm"
              v-if="!isForm && pageTitle === 'Past Events' ? false : true"
              >Add New Event</a-button
            >
          </div>
        </div>
        <div class="events-wrap" v-if="!isForm">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4 }"
            :dataSource="eventList"
            :pagination="pagination"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="event-detail"
            >
              <EventCard
                :key="index"
                :event="item"
                @onChange="editForm"
                @onDelete="deleteEvent"
                :id="id"
                :viewOnly="viewOnly"
              />
            </a-list-item>
          </a-list>
        </div>
        <div class="form-wrap" v-else>
          <div class="form-content">
            <h2 class="form-title" v-if="formType === 'save'">Add New Event</h2>
            <h2 class="form-title" v-else>Edit Event</h2>
            <a-form layout="horizontal" :form="form" @submit="handleSubmit">
              <div class="event-basic-info">
                <a-form-item label="Event Image">
                  <div class="dropbox">
                    <a-upload-dragger
                      name="file"
                      list-type="picture-card"
                      :file-list="fileList"
                      @preview="handlePreview"
                      :multiple="false"
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      @change="handleUploadChange"
                    >
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        Choose an image file or drag it here.
                      </p>
                    </a-upload-dragger>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                </a-form-item>
                <a-form-item
                  label="Title"
                  :validate-status="handleError('title') ? 'error' : ''"
                  :help="handleError('title') || ''"
                >
                  <a-input
                    v-decorator="[
                      'title',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter title of the Event!'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
                <a-form-item
                  label="Description"
                  :validate-status="handleError('description') ? 'error' : ''"
                  :help="handleError('description') || ''"
                >
                  <a-textarea
                    :auto-size="{ minRows: 8, maxRows: 8 }"
                    v-decorator="[
                      'description',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter title of the Event!'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="event-type-info">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <a-form-item
                      label="Event Type"
                      :validate-status="handleError('eventType') ? 'error' : ''"
                      :help="handleError('eventType') || ''"
                    >
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        @change="handleEventChange"
                        v-decorator="[
                          'eventType',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Event Type!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select Event Type"
                      >
                        <a-select-option
                          v-for="event in eventInfo.eventTypeList"
                          :key="event._id"
                          :value="event._id"
                          >{{ event.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team A">
                      <a-input v-decorator="['teamA']" />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team B">
                      <a-input v-decorator="['teamB']" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="date-time-info">
                <a-row :gutter="24">
                  <a-col :sm="8">
                    <a-form-item label="Date">
                      <a-date-picker
                        :style="{ width: '100%' }"
                        @change="onDateChange"
                        v-decorator="[
                          'date',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Date!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item label="Time">
                      <a-time-picker
                        :style="{ width: '100%' }"
                        format="HH:mm"
                        @change="onTimeChange"
                        v-decorator="[
                          'time',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Time!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item
                      label="Age Group"
                      :validate-status="handleError('age') ? 'error' : ''"
                      :help="handleError('age') || ''"
                    >
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'age',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Age Group!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select Age Group"
                      >
                        <a-select-option
                          v-for="age in eventInfo.ageGroupList"
                          :key="age._id"
                          :value="age._id"
                          >{{ age.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="location-info">
                <a-row :gutter="24">
                  <a-col :sm="12">
                    <a-form-item
                      label="City"
                      :validate-status="handleError('city') ? 'error' : ''"
                      :help="handleError('city') || ''"
                    >
                      <a-input
                        v-decorator="[
                          'city',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter City!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12">
                    <a-form-item
                      label="State"
                      :validate-status="handleError('state') ? 'error' : ''"
                      :help="handleError('state') || ''"
                    >
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'state',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select State!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select State"
                      >
                        <a-select-option
                          v-for="state in eventInfo.stateList"
                          :key="state._id"
                          :value="state._id"
                          >{{ state.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item
                      label="Location"
                      :validate-status="handleError('location') ? 'error' : ''"
                      :help="handleError('location') || ''"
                    >
                      <a-input
                        v-decorator="[
                          'location',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Location!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Google Location">
                      <a-input v-decorator="['googleLocation']" />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Sponsor">
                      <a-input
                        v-decorator="[
                          'sponsor',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please mention sponsor!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item>
                      <a-checkbox
                        :checked="checkHidden"
                        @change="handleChangeHidden"
                        >Hide on Profile?</a-checkbox
                      >
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>

              <a-form-item>
                <div class="button-wrapper">
                  <span>
                    <a-button
                      type="primary"
                      html-type="submit"
                      class="next-button save-button"
                      :disabled="hasErrors(form.getFieldsError())"
                      >Save</a-button
                    >
                  </span>
                  <span>
                    <a-button
                      type="primary"
                      class="next-button"
                      @click="cancelForm"
                      >Cancel</a-button
                    >
                  </span>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import EventCard from "./EventCard";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const STORE_KEY = "playerStore";
const taxonomyRepository = RepositoryFactory.get("taxonomy");
const eventsRepository = RepositoryFactory.get("events");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: "EventList",
  props: ["id"],
  components: {
    EventCard
  },
  data() {
    return {
      isForm: false,
      formType: "save",
      toEditId: "",
      currentEventType: "",
      viewOnly: false,
      pageTitle: "Upcoming Events",
      taxonomyvalues: [
        {
          name: "stateList",
          taxValue: "State"
        },
        {
          name: "ageGroupList",
          taxValue: "Age Group"
        },
        {
          name: "eventTypeList",
          taxValue: "Club Event Type"
        }
      ],
      previewVisible: false,
      previewImage: "",
      fileList: [],
      eventInfo: {
        stateList: [],
        eventTypeList: []
      },
      eventTime: "",
      eventList: [],
      checkHidden: false,
      hasErrors,
      form: this.$form.createForm(this),
      pagination: {
        onChange: page => ({}),
        pageSize: 8,
        simple: true,
        total: 1
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  created() {
    this.getUpcoming();

    for (let i = 0; i < this.taxonomyvalues.length; i++) {
      taxonomyRepository
        .getTaxonomyValues(this.taxonomyvalues[i].taxValue)
        .then(response => {
          this.eventInfo[this.taxonomyvalues[i].name] =
            response.data.taxonomy.values;
        });
    }
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          let toSend = {
            clubId: localStorage.getItem("club-id"),
            clubName: "testpod-podamibe",
            title: values.title,
            description: values.description,
            date: values.date,
            image: "string",
            state: values.state,
            city: values.city,
            location: values.location,
            age: values.age,
            googleLocation: values.googleLocation ? values.googleLocation : "",
            sponsor: values.sponsor,
            eventType: values.eventType,
            teamA: values.teamA ? values.teamA : "",
            teamB: values.teamB ? values.teamB : ""
          };
          toSend.displayOnProfile = !this.checkHidden;
          toSend.time = this.eventTime;
          if (this.formType === "save") {
            eventsRepository
              .postClubEvents(toSend)
              .then(response => {
                this.$message.success("New Event Added Successfully!");
                this.eventList.push(response.data.clubEvent);
                this.isForm = !this.isForm;
              })
              .catch(error => {
                this.$message.error("Error upload Event!");
              });
          } else {
            eventsRepository
              .editClubEvents(toSend, this.toEditId)
              .then(response => {
                this.$message.success("Event Updated Successfully!");
                let index = this.eventList.findIndex(
                  item => item._id === this.toEditId
                );
                if (index !== -1) {
                  this.eventList[index] = response.data.clubEvent;
                }
                this.isForm = !this.isForm;
              })
              .catch(error => {
                this.$message.error("Error upload Event!");
              });
          }
        }
      });
    },

    handleChangeHidden(e) {
      this.checkHidden = e.target.checked;
    },

    // Upload functions
    handleCancel() {
      this.previewVisible = false;
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.thumbUrl;
      this.previewVisible = true;
    },

    handleUploadChange(info) {
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;

      const status = info.file.status;
      if (status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    changeEvents(val) {
      if (val === "new") {
        this.getUpcoming();
      } else if (val === "past") {
        this.getPast();
      }
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
    },

    getUpcoming() {
      eventsRepository
        .getUpcomingClubEvents(localStorage.getItem("profile-id"))
        .then(response => {
          this.eventList = response.data.clubEvents;
          this.pageTitle = "Upcoming Events";
          this.pagination.total = response.results;
        });
    },

    getPast() {
      eventsRepository
        .getPastCollegeEvents(localStorage.getItem("profile-id"))
        .then(response => {
          this.eventList = response.data.clubEvents;
          this.pageTitle = "Past Events";
          this.pagination.total = response.results;
        });
    },

    handleEventChange(value) {
      let type = this.eventInfo.eventTypeList.filter(
        type => type._id === value
      );
      this.currentEventType = type[0].name;
    },

    onTimeChange(time, timeString) {
      this.eventTime = timeString;
    },

    saveForm() {
      this.isForm = !this.isForm;
      this.formType = "save";
    },
    cancelForm() {
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
    },
    editForm(value) {
      this.isForm = true;
      this.formType = "edit";
      this.toEditId = value._id;
      this.checkHidden = !value.displayOnProfile;
      let d = new Date(value.date);
      let that = this;
      if (value.eventType.name === "Game Schedule") {
        this.currentEventType = "Game Schedule";
      }
      setTimeout(function() {
        that.form.setFieldsValue({
          title: value.title,
          description: value.description,
          state: value.state._id
            ? value.state._id
            : value.state
            ? value.state
            : "",
          city: value.city,
          age: value.age._id ? value.age._id : value.age ? value.age : "",
          date: moment(d).format("YYYY-MM-DD"),
          time: moment(value.time, "HH:mm"),
          location: value.location,
          googleLocation: value.googleLocation,
          sponsor: value.sponsor,
          eventType: value.eventType._id
            ? value.eventType._id
            : value.eventType
            ? value.eventType
            : "",
          teamA: value.teamA ? value.teamA : "",
          teamB: value.teamB ? value.teamB : ""
        });
      }, 1000);
    },
    deleteEvent(id) {
      let index = this.eventList.findIndex(item => item._id === id);
      this.eventList.splice(index, 1);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    }
  }
};
</script>
